var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcons8LinkedinSideBar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.955,
    height: 9.955,
    viewBox: "0 0 9.955 9.955",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #586f93;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8_linkedin_1",
    className: "cls-1",
    d: "M7.521,6A1.527,1.527,0,0,0,6,7.521v6.913a1.527,1.527,0,0,0,1.521,1.521h6.913a1.527,1.527,0,0,0,1.521-1.521V7.521A1.527,1.527,0,0,0,14.434,6Zm0,.83h6.913a.685.685,0,0,1,.691.691v6.913a.685.685,0,0,1-.691.691H7.521a.685.685,0,0,1-.691-.691V7.521A.685.685,0,0,1,7.521,6.83ZM8.627,7.936a.691.691,0,1,0,.691.691.691.691,0,0,0-.691-.691ZM8.212,9.872a.276.276,0,0,0-.277.277v3.595a.276.276,0,0,0,.277.277h.83a.276.276,0,0,0,.277-.277V10.148a.276.276,0,0,0-.277-.277Zm1.936,0a.276.276,0,0,0-.277.277v3.595a.276.276,0,0,0,.277.277h.83a.276.276,0,0,0,.277-.277V11.669a.691.691,0,1,1,1.383,0v2.074a.276.276,0,0,0,.277.277h.83a.276.276,0,0,0,.277-.277V11.531A1.656,1.656,0,0,0,11.254,10.3v-.15a.276.276,0,0,0-.277-.277Z",
    transform: "translate(-6 -6)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8LinkedinSideBar);
export default __webpack_public_path__ + "static/media/icons8_linkedin_Side-bar.636bd59e90f79b735c251d25cc82b539.svg";
export { ForwardRef as ReactComponent };